import { render } from "./BracketView.vue?vue&type=template&id=66cf8a2f&scoped=true"
import script from "./BracketView.vue?vue&type=script&lang=js"
export * from "./BracketView.vue?vue&type=script&lang=js"

import "./BracketView.vue?vue&type=style&index=0&id=66cf8a2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cf8a2f"]])

export default __exports__